/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.yml` */
import * as Types from './types';

import gql from 'graphql-tag';
import * as Urql from '../../abstractions/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetUsersForListQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.Scalars['JSON']>;
  sort?: Types.InputMaybe<Types.Scalars['JSON']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetUsersForListQuery = { __typename?: 'Query', users: { __typename?: 'UserListResponse', data: Array<{ __typename?: 'User', id: number, name?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null, position?: string | null, email?: string | null, active?: boolean | null, company?: { __typename?: 'Company', id: number, name?: string | null, active: boolean } | null }>, pageData?: { __typename?: 'PageData', count: number, limit: number } | null } };

export type GetUsersForFilterQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.Scalars['JSON']>;
  sort?: Types.InputMaybe<Types.Scalars['JSON']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetUsersForFilterQuery = { __typename?: 'Query', users: { __typename?: 'UserListResponse', data: Array<{ __typename?: 'User', id: number, name?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null }>, pageData?: { __typename?: 'PageData', count: number, limit: number } | null } };

export type GetUsersForNotesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUsersForNotesQuery = { __typename?: 'Query', getUsersForNotes: Array<{ __typename?: 'User', id: number, name?: string | null, username?: string | null, firstName?: string | null, lastName?: string | null }> };

export type GetUserQueryVariables = Types.Exact<{
  query: Types.Scalars['JSON'];
}>;


export type GetUserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: number, name?: string | null, username?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, mobile?: string | null, config?: any | null, active?: boolean | null, position?: string | null, chatAlias?: string | null, company?: { __typename?: 'Company', id: number, name?: string | null, owner?: boolean | null } | null } };

export type UserDataFragment = { __typename?: 'User', id: number, name?: string | null, username?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, mobile?: string | null, config?: any | null, active?: boolean | null, position?: string | null, chatAlias?: string | null, company?: { __typename?: 'Company', id: number, name?: string | null, owner?: boolean | null } | null };

export type SaveUserProfileMutationVariables = Types.Exact<{
  user: Types.UserInput;
}>;


export type SaveUserProfileMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'User', id: number, username?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, mobile?: string | null, position?: string | null, name?: string | null, chatAlias?: string | null } };

export type SaveUserNotificationSettingsMutationVariables = Types.Exact<{
  user: Types.UserInput;
}>;


export type SaveUserNotificationSettingsMutation = { __typename?: 'Mutation', saveNotificationSettings: { __typename?: 'User', id: number, config?: any | null } };

export type InviteUsersMutationVariables = Types.Exact<{
  users: Array<Types.UserInput> | Types.UserInput;
  companyId: Types.Scalars['Int'];
}>;


export type InviteUsersMutation = { __typename?: 'Mutation', inviteUsers: Array<string> };

export type ChangePasswordMutationVariables = Types.Exact<{
  username: Types.Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type EnableUserMutationVariables = Types.Exact<{
  userId: Types.Scalars['Int'];
}>;


export type EnableUserMutation = { __typename?: 'Mutation', enableUser: boolean };

export type DisableUserMutationVariables = Types.Exact<{
  userId: Types.Scalars['Int'];
}>;


export type DisableUserMutation = { __typename?: 'Mutation', disableUser: boolean };

export type GetDirectoryUserQueryVariables = Types.Exact<{
  username: Types.Scalars['String'];
}>;


export type GetDirectoryUserQuery = { __typename?: 'Query', getDirectoryUser: any };

export type EnableOtpMutationVariables = Types.Exact<{
  username: Types.Scalars['String'];
}>;


export type EnableOtpMutation = { __typename?: 'Mutation', enableOTP: boolean };

export type DisableOtpMutationVariables = Types.Exact<{
  username: Types.Scalars['String'];
}>;


export type DisableOtpMutation = { __typename?: 'Mutation', disableOTP: boolean };

export const UserDataFragmentDoc = gql`
    fragment UserData on User {
  id
  name
  username
  email
  firstName
  lastName
  mobile
  config
  active
  company {
    id
    name
    owner
  }
  position
  chatAlias
}
    `;
export const GetUsersForListDocument = gql`
    query GetUsersForList($query: JSON, $sort: JSON, $limit: Int, $skip: Int) {
  users(query: $query, sort: $sort, limit: $limit, skip: $skip) {
    data {
      id
      name
      username
      firstName
      lastName
      position
      email
      active
      company {
        id
        name
        active
      }
    }
    pageData {
      count
      limit
    }
  }
}
    `;

export function useGetUsersForListQuery(options?: Omit<Urql.UseQueryArgs<GetUsersForListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUsersForListQuery>({ query: GetUsersForListDocument, ...options });
};
export const GetUsersForFilterDocument = gql`
    query GetUsersForFilter($query: JSON, $sort: JSON, $limit: Int, $skip: Int) {
  users(query: $query, sort: $sort, limit: $limit, skip: $skip) {
    data {
      id
      name
      firstName
      lastName
      email
    }
    pageData {
      count
      limit
    }
  }
}
    `;

export function useGetUsersForFilterQuery(options?: Omit<Urql.UseQueryArgs<GetUsersForFilterQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUsersForFilterQuery>({ query: GetUsersForFilterDocument, ...options });
};
export const GetUsersForNotesDocument = gql`
    query GetUsersForNotes {
  getUsersForNotes {
    id
    name
    username
    firstName
    lastName
  }
}
    `;

export function useGetUsersForNotesQuery(options?: Omit<Urql.UseQueryArgs<GetUsersForNotesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUsersForNotesQuery>({ query: GetUsersForNotesDocument, ...options });
};
export const GetUserDocument = gql`
    query GetUser($query: JSON!) {
  user(query: $query) {
    ...UserData
  }
}
    ${UserDataFragmentDoc}`;

export function useGetUserQuery(options: Omit<Urql.UseQueryArgs<GetUserQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserQuery>({ query: GetUserDocument, ...options });
};
export const SaveUserProfileDocument = gql`
    mutation SaveUserProfile($user: UserInput!) {
  updateProfile(user: $user) {
    id
    username
    email
    firstName
    lastName
    mobile
    position
    name
    chatAlias
  }
}
    `;

export function useSaveUserProfileMutation() {
  return Urql.useMutation<SaveUserProfileMutation, SaveUserProfileMutationVariables>(SaveUserProfileDocument);
};
export const SaveUserNotificationSettingsDocument = gql`
    mutation SaveUserNotificationSettings($user: UserInput!) {
  saveNotificationSettings(user: $user) {
    id
    config
  }
}
    `;

export function useSaveUserNotificationSettingsMutation() {
  return Urql.useMutation<SaveUserNotificationSettingsMutation, SaveUserNotificationSettingsMutationVariables>(SaveUserNotificationSettingsDocument);
};
export const InviteUsersDocument = gql`
    mutation InviteUsers($users: [UserInput!]!, $companyId: Int!) {
  inviteUsers(users: $users, companyId: $companyId)
}
    `;

export function useInviteUsersMutation() {
  return Urql.useMutation<InviteUsersMutation, InviteUsersMutationVariables>(InviteUsersDocument);
};
export const ChangePasswordDocument = gql`
    mutation ChangePassword($username: String!) {
  changePassword(username: $username)
}
    `;

export function useChangePasswordMutation() {
  return Urql.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument);
};
export const EnableUserDocument = gql`
    mutation EnableUser($userId: Int!) {
  enableUser(userId: $userId)
}
    `;

export function useEnableUserMutation() {
  return Urql.useMutation<EnableUserMutation, EnableUserMutationVariables>(EnableUserDocument);
};
export const DisableUserDocument = gql`
    mutation DisableUser($userId: Int!) {
  disableUser(userId: $userId)
}
    `;

export function useDisableUserMutation() {
  return Urql.useMutation<DisableUserMutation, DisableUserMutationVariables>(DisableUserDocument);
};
export const GetDirectoryUserDocument = gql`
    query GetDirectoryUser($username: String!) {
  getDirectoryUser(username: $username)
}
    `;

export function useGetDirectoryUserQuery(options: Omit<Urql.UseQueryArgs<GetDirectoryUserQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDirectoryUserQuery>({ query: GetDirectoryUserDocument, ...options });
};
export const EnableOtpDocument = gql`
    mutation EnableOTP($username: String!) {
  enableOTP(username: $username)
}
    `;

export function useEnableOtpMutation() {
  return Urql.useMutation<EnableOtpMutation, EnableOtpMutationVariables>(EnableOtpDocument);
};
export const DisableOtpDocument = gql`
    mutation DisableOTP($username: String!) {
  disableOTP(username: $username)
}
    `;

export function useDisableOtpMutation() {
  return Urql.useMutation<DisableOtpMutation, DisableOtpMutationVariables>(DisableOtpDocument);
};